import React, { useRef, useState } from 'react'
import { CreateFindingsSchema } from 'utils/validation';
import Select from 'components/Select';
import Button from 'components/Button/Button';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { removeEmpty } from 'utils/removeEmptyValues';
import { createDiagnosticFindingsAction, getFindingsPerProcedureAction } from 're-ducks/report';
import { Form, Formik } from 'formik';
import styles from '../report.module.scss';
import FormInput from 'components/FormInput/FormInput';
import CreateDiagnosticNotes from './createDiagnosticNotes';

const CreateFindings = ({ setAddNewFindings, setFindings, edit, isClose }) => {
  const [selectedReportType, setSelectedReportType] = useState({});
  const params = useParams();
  const stepOneRef = useRef(null);
  const [stepTwoResetKey, setStepTwoResetKey] = useState(0);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState("");
  const [findingsId, setFindingsId] = useState("");
  


    const resetAll = () => {
        setFindingsId(null);
    
        if (stepOneRef.current) {
          stepOneRef.current.resetForm();
        }

        dispatch({
          type: 'SET_SINGLE_REPORT',
          payload: null
        });
        setAddNewFindings && setAddNewFindings(false);
        if(edit){
          isClose();
            dispatch(
                    getFindingsPerProcedureAction(
                      {
                        test_id: params?.code
                      },
                      (res) => {
                        setFindings(res?.data)
                      },
                      (err) => {
                        toast.error(err)
                      }
                    )
                )
        }
    
        setStepTwoResetKey(prev => prev + 1);
      };
    
      const commaSeperatedValues = (data) => {
        return data?.split('\n')
        ?.filter(item => item.trim() !== '')
        ?.join(',');
      }
      
    const handleCreateDiagnosticFindings = (values) => {
        const data = removeEmpty(values)
        const res =   {
          pick_checkers: commaSeperatedValues(values.pick_checkers)
        }
        const others = removeEmpty(res)
        setIsLoading(true);
        dispatch(
          createDiagnosticFindingsAction(
            {
              ...data,
              ...others,
              test_ids: params?.code,
              from: "single"
            },
            (res) => {
              setIsLoading(false);
              toast.success(res.message);
              setFindingsId(res?.data?.[0]?.id)
            },
            (err) => {
              setIsLoading(false)
              toast.error(err)
            }
          )
        )
      }

    const reportTypes = [
        { name: "Personal report", id: "Personal report"},
        { name: "Corporate report", id: "Corporate report"}
    ]
    
  return (
    <div className={styles.create_diagnostics__form}>
            <Formik
              initialValues={{
                title: "",
                description: "",
                note_tied_to: "",
                pick_checkers: ""
              }}
              innerRef={stepOneRef}
              onSubmit={(values) => {
                handleCreateDiagnosticFindings(values)
              }}
              validationSchema={CreateFindingsSchema}
            >
              {(formik) => {
                return(
                  <Form>
                    <div className={styles.create_diagnostics__form__input}>
                      <Select
                        label="Report Type" 
                        placeholder="Select report type"
                        options={reportTypes}
                        name="note_tied_to"
                        selected={selectedReportType}
                        handleChange={(e) => {
                          formik.setFieldValue('note_tied_to', e.name);
                            setSelectedReportType(e)
                        }}
                        disabled={findingsId}
                      />
                    {formik.errors.note_tied_to ? (
                      <span className="error">{formik.errors.note_tied_to}</span>
                    ) : null}
                  </div>
                    <div className={styles.create_diagnostics__form__input}>
                      <FormInput
                        label= "Title"
                        type="text"
                        value={formik.values.title}
                        onChange={formik.handleChange}
                        name="title"
                        disabled={findingsId}
                      />
                       {formik.errors.title ? (
                          <span className="error">{formik.errors.title}</span>
                        ) : null}
                    </div>
                    <div className={styles.create_diagnostics__textarea}>
                      <p>Description</p>
                      <textarea
                        name="description"
                        value={formik.values.description}
                        onChange={formik.handleChange}
                        disabled={findingsId}
                      />
                    </div>
                    <div className={styles.create_diagnostics__textarea}>
                      <p>Pick Checkers</p>
                        <textarea
                         name="pick_checkers"
                         value={formik.values.pick_checkers}
                         onChange={formik.handleChange}
                         disabled={findingsId}
                       />
                    </div>
                    <div className={styles.create_diagnostics__continueBtn}>
                      <Button 
                      theme="primary" 
                      type="submit"
                      disabled={findingsId || !formik.isValid || !formik.dirty}
                      loading={isLoading}>Save & Continue</Button>
                    </div> 
                  </Form>
                )
              }}

            </Formik>
            <CreateDiagnosticNotes
              isDisabled={!findingsId}
              findingsId={findingsId}
              key={stepTwoResetKey}
              resetAll={resetAll}
              selectedReportType={selectedReportType}
              setSelectedReportType={setSelectedReportType}
            />

          </div>
  )
}

export default CreateFindings